<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Referrals"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="button" @click="$router.push({ name: 'referrals.new' })" class="btn btn--primary btn--primary--sml" v-if="checkPermission('articles', 'create')">New Referral Code</app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('forms', 'view')">
                <app-table v-if="referrals.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Name
                            </app-table-cell>
                            <app-table-cell :header="true">
                                Code
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Usage
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true">
                                Active
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(f, i) in referrals" :key="i">
                            <app-table-cell>
                                {{ f.name }}
                            </app-table-cell>
                            <app-table-cell>
                                {{ f.code }}
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                {{ f.usage }} time(s)
                            </app-table-cell>
                            <app-table-cell class="text-center">
                                <app-icon :icon="f.active ? 'check-circle' : 'times-circle'" :class="{'text-green': f.active, 'text-red': !f.active, 'text-lg': true}" />
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'referrals.edit', params: { id: f.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('forms', 'edit')">
                                    <app-icon icon="edit" />
                                </router-link>
                                <app-icon icon="trash" class="text-red cursor-pointer" @click="confirmModalOpened = true; confirmModalId = f.id" v-if="checkPermission('articles', 'delete')" />
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>
            </app-box>
        </app-content>

        <app-confirm-modal
            v-if="confirmModalOpened"
            @confirm="remove"
            @close="confirmModalOpened = false; confirmModalId = false"
            actionText="Yes please"
            cancelText="No thanks"
            heading="Hang on!"
            text="You are about to delete a referral code. Are you sure you wish to continue?"
        />
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';

    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import ConfirmModal from '@/components/modals/ConfirmModal';

    /* Mixins */
    import Query from '@/mixins/query';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'referrals.home',

        data: () => ({
            loading: true,
            referrals: [],
            confirmModalOpened: false,
            confirmModalId: false
        }),

        mixins: [ Query, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-confirm-modal': ConfirmModal
        },

        mounted() {
            this.get().then(() => {
                this.loading = false;
            });
        },

        methods: {
            get() {
                return Api.request('get', `referrals`)
                    .then(({ data }) => {
                        this.referrals = data.referrals;
                    });
            },

            remove(id) {
                this.confirmModalOpened = false;
                this.loading = true;

                return Api.request('get', `referrals/delete/${this.confirmModalId}`).then(() => {
                    this.confirmModalId = false;
                    return this.get();
                }).then(() => {
                    this.loading = false;
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/referrals/Home.vue